<template>
  <div>
    <Card>
      <Row class="search-con" type="flex" align="middle" :gutter="10">
        <Col span="4">
          <Input clearable placeholder="输入关键字搜索" class="search-input" v-model="keyword" />
        </Col>
        <Col span="3">
          <Select v-model="selectedType" placeholder="请选择类型" clearable style="width: 100%;" @on-change="handleButtonSearch">
            <Option v-for="type in typeList" :value="type" :key="type">
              {{ type }}
            </Option>
          </Select>
        </Col>
        <Col span="2">
          <Button @click="handleButtonSearch" class="search-btn" type="primary">搜索</Button>
        </Col>
        <Col span="4">
          <Button @click="showAddModal" type="primary">添加</Button>
        </Col>
      </Row>
      <tables editable :columns="columns" :value="tableData" :loading="tableLoading" ref="tables" />
      <Row class="page-con">
        <div class="page-bottom">
          <Page :current="page" :total="total" :page-size="pageSize" show-sizer show-elevator @on-change="changePage"
            @on-page-size-change="changePageSize" />
        </div>
      </Row>
    </Card>

    <Modal :mask-closable="false" v-model="addModal" title="添加" footer-hide>
      <forms :resetFlag="resetFlag" ref="add" @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>

    <Modal :mask-closable="false" v-model="editModal" title="编辑" footer-hide>
      <forms :resetFlag="resetFlag" ref="edit" @on-ok="editSumit" @on-cancel="cancel" />
    </Modal>

  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./add_soft_version_form.vue";
import {baseVersionList, createBaseVersion, updateBaseVersion, deleteBaseVersion, getVersionTypes} from "@/api/data";
import { getTimeDifference} from "@/api/uploadOss";

export default {
  name: "finance",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      keyword:'',
      selectedType: null, // 选中的类型
      typeList: [], // 类型列表
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      allMoney: 0.0,
      startTime: "",
      endTime: "",
      columns: [
        { type: 'index', title: '序号', width: 100, align: "center" },
        { title: "版本类型", key: "versionType", minWidth: 120, editable: true, align: "center" },
        { title: "版本名称", key: "versionName", minWidth: 150, editable: true },
        { title: "版本号", key: "versionCode", minWidth: 100, editable: true },
        { title: "版本描述", key: "comment", minWidth: 200, editable: true },
        {
          title: "软件地址", key: "url", minWidth: 200, editable: true, align: "center",
          render: (h, params) => {
            return params.row.url != '' ? h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(params.row.url);
                    },
                  },
                },
                "下载"
              )
            ]) : h('span', '');
          },
        },
        { title: "创建时间", key: "createTime", editable: true,render: (h, params) => {
            let texts = getTimeDifference(params.row.createTime)
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }},
        { title: "更新时间", key: "updateTime", editable: true,render: (h, params) => {
            let texts = getTimeDifference(params.row.updateTime)
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }},
          {
          title: "Handle",
          key: "handle", width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "编辑"
              ), h(
                "Button",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              )
            ]);
          },
        }
      ],
      tableData: [],
    };
  },
  methods: {
    download(url) {
      window.open(url, '_blank');
    },
    handleButtonSearch() {
      this.page = 1
      this.handleSearch()
    },
    changeStatus(value, params){
      let data = new FormData();
      data.append("open", value);
      edit_device(params.row.id, data).then((res) => {
        if (res.data.code == 200) {
          this.handleSearch()
          this.$Message.success("成功!");
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    download(url) {
      window.open(url, '_blank');
    },
    showAddModal() {
      this.addModal = true;
      this.resetFlag = !this.resetFlag;
    },
    showEditModal(params) {
      this.editData = params.row;
      this.editModal = true;
      this.$refs.edit.setEditData(this.editData)
    },
    cancel() { },
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        current: this.page,
        pageSize: this.pageSize,
        versionName: this.keyword
      };
      
      // 如果选择了类型，则传递 versionType 参数
      if (this.selectedType) {
        params.versionType = this.selectedType;
      }

      baseVersionList(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      }).catch((err) => {
        console.error('API调用失败:', err);
        this.setTableLoading(false);
      });
    },
    addSumit(formValidate) {
      const data = {
        versionName: formValidate.versionName,
        versionCode: parseInt(formValidate.versionCode),
        comment: formValidate.comment,
        url: formValidate.downloadUrl,
        versionType: formValidate.versionType || 'aiqc',
        md5: formValidate.md5,
        unzipPath: formValidate.unzipPath || '/home/sinano/images/triton_server/models_10.3',
        dockerName: formValidate.dockerName || 'tritonserver-gpu'
      }
      createBaseVersion(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    editSumit(formValidate) {
      const data = {
        versionName: formValidate.versionName,
        versionCode: parseInt(formValidate.versionCode),
        comment: formValidate.comment,
        url: formValidate.downloadUrl,
        versionType: formValidate.versionType || 'aiqc',
        md5: formValidate.md5,
        unzipPath: formValidate.unzipPath || '/home/sinano/images/triton_server/models_10.3',
        dockerName: formValidate.dockerName || 'tritonserver-gpu'
      }
      updateBaseVersion(formValidate.id, data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
    handleDelete(params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除？删除后相关补丁包也会被删除。</p>',
        onOk: () => {
          deleteBaseVersion(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });
    },
    async loadTypeList() {
      try {
        const res = await getVersionTypes();
        if (res.data.code === 200) {
          this.typeList = res.data.data || [];
        } else {
          this.$Message.error('获取类型列表失败: ' + (res.data.msg || '未知错误'));
          this.typeList = [];
        }
      } catch (error) {
        this.$Message.error('加载类型列表失败');
        console.error(error);
        this.typeList = [];
      }
    },
  },
  async mounted() {
    await this.loadTypeList();
    this.handleSearch();
  },
};
</script>
